import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import SocialIcon, { ISimplifiedSocialButtonProps } from '@gik/ui/SocialIcon/SocialIcon';

const blockName = 'instagram-icon';

export default function InstagramIcon({ className, ...otherProps }: ISimplifiedSocialButtonProps) {
  const bem = bemBlock(blockName);

  return (
    <SocialIcon
      className={bem(null, null, [className])}
      icon={{
        set: 'brand-icons',
        name: 'Instagram',
      }}
      {...otherProps}
    />
  );
}
